// keep-or-cancel-curation-quiz.js
(() => {
  const root = document.querySelector("[data-kocq]");
  if (!root) return;

  // ✅ NEW: Start + Stage wrapper (Hands Off pattern)
  const startBtn = document.getElementById("kocqStart");
  const stageWrap = document.getElementById("kocqStage");

  const stageEl = root.querySelector("[data-kocq-stage]");
  const formEl = root.querySelector("[data-kocq-form]");
  const prevBtn = root.querySelector("[data-kocq-prev]");
  const nextBtn = root.querySelector("[data-kocq-next]");
  const barEl = root.querySelector("[data-kocq-bar]");
  const countEl = root.querySelector("[data-kocq-count]");
  const resultWrap = root.querySelector("[data-kocq-result]");
  const resultTitleEl = root.querySelector("[data-kocq-result-title]");
  const resultBlurbEl = root.querySelector("[data-kocq-result-blurb]");
  const resultLinkEl = root.querySelector("[data-kocq-result-link]");
  const restartBtn = root.querySelector("[data-kocq-restart]");

  // If the new wrapper exists, use it; otherwise behave like before
  const hasStageWrap = !!stageWrap;

  if (
    !stageEl ||
    !formEl ||
    !prevBtn ||
    !nextBtn ||
    !barEl ||
    !countEl ||
    !resultWrap ||
    !resultTitleEl ||
    !resultBlurbEl ||
    !resultLinkEl ||
    !restartBtn
  ) {
    return;
  }

  const collections = {
    "The Architect": "https://jtvsky.com/collections/the-architect?src=quiz",
    "Power Moves": "https://jtvsky.com/collections/power-moves?src=quiz",
    "Pink Over Practical": "https://jtvsky.com/collections/pink-over-practical?src=quiz",
    "Beige Allergy": "https://jtvsky.com/collections/beige-allergy?src=quiz",
    "Late Checkout": "https://jtvsky.com/collections/late-checkout?src=quiz",
    "She’s Off-Duty": "https://jtvsky.com/collections/shes-off-duty?src=quiz"
  };

  // Letter -> Aesthetic mapping (locked)
  const letterToAesthetic = {
    A: "Power Moves",
    B: "She’s Off-Duty",
    C: "Pink Over Practical",
    D: "The Architect",
    E: "Beige Allergy",
    F: "Late Checkout"
  };

  const resultCopy = {
    "Power Moves": {
      title: "You’re Power Moves.",
      blurb:
        "You’re decisive. You don’t negotiate with doubt. If something needs handling, you handle it. People call it intimidating because you don’t soften your edges for comfort."
    },
    "She’s Off-Duty": {
      title: "You’re She’s Off-Duty.",
      blurb:
        "You’re the calm one. You keep things light, you keep things moving, and you notice when someone’s uncomfortable before they say it out loud. You don’t need the room. You just make it easier to be in."
    },
    "Pink Over Practical": {
      title: "You’re Pink Over Practical.",
      blurb:
        "You’re warm, optimistic, and slightly delusional in the best way. You choose feeling over logic. You see the best in people. You buy the thing because you like it, not because it makes sense."
    },
    "The Architect": {
      title: "You’re The Architect.",
      blurb:
        "You notice patterns other people miss. You don't rush decisions and you rarely show your full hand. While everyone else is reacting, you're already three steps ahead. People assume things happen by accident around you. They don't."
    },
    "Beige Allergy": {
      title: "You’re Beige Allergy.",
      blurb:
        "You get bored fast. You notice details other people miss. You don’t like neutral answers. If something feels predictable, you’re already over it. You’re not here to blend in."
    },
    "Late Checkout": {
      title: "You’re Late Checkout.",
      blurb:
        "You’re optionality in human form. You don’t chase access. You show up when you feel like it, and you leave without explaining. If you want it, you can have it. If you don’t, you won’t pretend."
    }
  };

  const questions = [
    {
      id: "q1",
      prompt: "1. You get paid. What happens first?",
      options: {
        A: "I upgrade something immediately.",
        B: "I move money somewhere safe.",
        C: "I buy something unnecessary.",
        D: "I replace something but pretend it was practical.",
        E: "I invest it after reviewing everything.",
        F: "I deposit it a week later."
      }
    },
    {
      id: "q2",
      prompt: "2. Someone describes you as intimidating. Your reaction?",
      options: {
        A: "Good.",
        B: "I immediately apologize.",
        C: "I smile and promise I’m actually nice.",
        D: "I let them sit with that.",
        E: "I ask what specifically felt that way.",
        F: "I say “ok” and walk away."
      }
    },
    {
      id: "q3",
      prompt: "3. You’re overdressed. What do you do?",
      options: {
        A: "I make it look intentional.",
        B: "I apologize for overdressing.",
        C: "I turn it into a joke.",
        D: "I note who’s uncomfortable.",
        E: "I ask if the dress code changed.",
        F: "I leave."
      }
    },
    {
      id: "q4",
      prompt: "4. Your toxic trait?",
      options: {
        A: "I escalate.",
        B: "I smooth things over too fast.",
        C: "I see the best in people. Every time.",
        D: "I keep score quietly.",
        E: "I overanalyze everything.",
        F: "I disappear instead of explaining."
      }
    },
    {
      id: "q5",
      prompt: "5. Pick a sentence that feels natural in your mouth.",
      options: {
        A: "“I’ll handle it.”",
        B: "“It’s fine.”",
        C: "“Are you okay?”",
        D: "“Interesting.”",
        E: "“Why?”",
        F: "“I’m good.”"
      }
    },
    {
      id: "q6",
      prompt: "6. If you were a 2000s tabloid headline:",
      options: {
        A: "Showed Up Late. Didn’t Apologize.",
        B: "Apologized to the Host for “Taking Up Space.”",
        C: "Laughed Off Awkward Toast, Changed the Topic.",
        D: "Gave One-Word Answers to Reporters.",
        E: "Cornered a Producer with “Just One Question.”",
        F: "Was Invited to the Exclusive Event — Didn’t Show."
      }
    },
    {
      id: "q7",
      prompt: "7. What makes something valuable to you?",
      options: {
        A: "If it shifts the room.",
        B: "If it keeps the peace.",
        C: "If it feels good right now.",
        D: "If it gives me an edge.",
        E: "If it holds up when questioned.",
        F: "If I don’t need it — but can have it if I want it."
      }
    },
    {
      id: "q8",
      prompt: "8. You’re leaving dinner. What’s actually happening?",
      options: {
        A: "I got invited somewhere hard to get into.",
        B: "Everyone else left and I stayed so the host wouldn’t feel bad.",
        C: "I promised my little sister a girls’ night.",
        D: "I got what I came for.",
        E: "The conversation stopped being productive.",
        F: "I Irish goodbye’d."
      }
    }
  ];

  const answers = {};
  let idx = 0;

  // ✅ NEW: gate quiz until Start is clicked (only when stage wrapper exists)
  let started = !hasStageWrap;

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function renderQuestion() {
    const q = questions[idx];
    const total = questions.length;

    countEl.textContent = `Question ${idx + 1} of ${total}`;
    const pct = (idx / total) * 100;
    barEl.style.width = `${pct}%`;

    const picked = answers[q.id] || "";

    const optionsHtml = Object.entries(q.options)
      .map(([key, text]) => {
        const checked = picked === key ? "checked" : "";
        return `
          <label class="kocq__opt">
            <input class="kocq__radio" type="radio" name="${q.id}" value="${key}" ${checked} />
            <div class="kocq__optText">
              <span>${escapeHtml(text)}</span>
            </div>
          </label>
        `;
      })
      .join("");

    stageEl.innerHTML = `
      <h3 class="kocq__qTitle">${escapeHtml(q.prompt)}</h3>
      <div class="kocq__answers">${optionsHtml}</div>
    `;

    prevBtn.disabled = idx === 0;
    nextBtn.textContent = idx === total - 1 ? "See results" : "Next";
  }

  function captureCurrentAnswer() {
    const q = questions[idx];
    const selected = stageEl.querySelector(`input[name="${q.id}"]:checked`);
    if (!selected) return null;
    answers[q.id] = selected.value;
    return selected.value;
  }

  function computeWinnerLetter() {
    const counts = { A: 0, B: 0, C: 0, D: 0, E: 0, F: 0 };

    for (const q of questions) {
      const a = answers[q.id];
      if (a && counts[a] !== undefined) counts[a] += 1;
    }

    let max = 0;
    for (const k of Object.keys(counts)) {
      max = Math.max(max, counts[k]);
    }

    const tied = Object.keys(counts).filter((k) => counts[k] === max);
    if (tied.length === 1) return tied[0];

    const weightQs = ["q6", "q7", "q8"];
    for (let i = weightQs.length - 1; i >= 0; i--) {
      const qid = weightQs[i];
      const pick = answers[qid];
      if (pick && tied.includes(pick)) return pick;
    }

    tied.sort();
    return tied[0];
  }

  function showResults() {
    barEl.style.width = "100%";
    formEl.hidden = true;
    resultWrap.hidden = false;

    const winnerLetter = computeWinnerLetter();
    const aesthetic = letterToAesthetic[winnerLetter] || "Power Moves";
    const copy = resultCopy[aesthetic] || resultCopy["Power Moves"];
    const url = collections[aesthetic] || collections["Power Moves"];

    resultTitleEl.textContent = copy.title;
    resultBlurbEl.textContent = copy.blurb;
    resultLinkEl.setAttribute("href", url);

    resultWrap.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  function restart() {
    for (const q of questions) {
      delete answers[q.id];
    }
    idx = 0;
    resultWrap.hidden = true;
    formEl.hidden = false;
    renderQuestion();

    const scrollTarget = hasStageWrap ? stageWrap : root;
    scrollTarget.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  prevBtn.addEventListener("click", () => {
    if (!started) return;
    captureCurrentAnswer();
    if (idx > 0) idx -= 1;
    renderQuestion();
  });

  nextBtn.addEventListener("click", () => {
    if (!started) return;

    const selected = captureCurrentAnswer();
    const isLast = idx === questions.length - 1;

    if (!selected) {
      nextBtn.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-3px)" },
          { transform: "translateX(3px)" },
          { transform: "translateX(0)" }
        ],
        { duration: 220, iterations: 1 }
      );
      return;
    }

    if (isLast) {
      showResults();
      return;
    }

    idx += 1;
    renderQuestion();
  });

  stageEl.addEventListener("change", (e) => {
    if (!started) return;

    const target = e.target;
    if (!target || target.type !== "radio") return;

    if (idx < questions.length - 1) {
      setTimeout(() => nextBtn.click(), 80);
    }
  });

  restartBtn.addEventListener("click", restart);

  // ✅ NEW: Start button behavior (only if the new Liquid wrapper exists)
  if (hasStageWrap) {
    stageWrap.hidden = true;

    if (startBtn) {
      startBtn.addEventListener("click", () => {
        if (started) return;
        started = true;

        stageWrap.hidden = false;
        startBtn.disabled = true;

        // Reset UI state just in case
        resultWrap.hidden = true;
        formEl.hidden = false;
        barEl.style.width = "0%";
        countEl.textContent = `Question 1 of ${questions.length}`;

        renderQuestion();

        stageWrap.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    }
  }

  // If no wrapper, keep original behavior
  if (!hasStageWrap) {
    renderQuestion();
  }
})();
